<template>
    <div class="photo">
        <template v-if="!loading">
            <div class="list_wrap_mobile">
                <div class="content_title">{{menuName}}</div>
                <div v-if="listLoading" class="loading"></div>
                <div class="list" v-else-if="list.length > 0">
                    <router-link class="item" v-for="item in list" :key="item.id" :to="`detail/${item.id}`">
                        <div class="cover" :style="`background-image: url(${item.image});`"></div>
                        <p class="title">{{item.title}}</p>
                    </router-link>
                </div>
                <div v-else class="nothing">{{$t('nothing')}}</div>
            </div>
            <Pagination :page="allPage" @change="changePage"/>
        </template>
        <div v-else class="loading"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from '../components/pagination.vue';
export default {
    name: "photo",
    data() {
        return {
            loading: false,
            list: [],
            listLoading: false,
            allPage: 1,
            nowPage: 1,
            limit: 6,
        };
    },
    computed: {
        ...mapState(['menuName']),
    },
    components: {
        Pagination
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.params.id': {
            handler: function(){
                this.loading = true;
                this.allPage = 1;
                this.nowPage = 1;
                this.getList();
            },
            immediate: true
        }
    },
    methods: {
        getList(){
            this.listLoading = true;
            this.list = [];
            this.$store.dispatch('getPhoto', {
                id: this.$route.params.id,
                page: this.nowPage,
                limit: this.limit,
            }).then((result)=>{
                this.loading = false;
                this.listLoading = false;
                this.list = result.list;
                this.allPage = result.last_page;
                this.nowPage = result.current_page;
            });
        },
        changePage(page){
            this.nowPage = page;
            this.getList();
        },
    },
};
</script>

<style scoped lang="scss">
.photo{
    width: 910px;
    margin-left: 56px;
    .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        // padding-right: 200px;
        .item{
            width: 275px;
            margin: 0 30px 20px;
            .cover{
                width: 100%;
                height: 182px;
                background-size: cover;
                background-position: center;
            }
            .title{
                text-align: center;
                font-size: 18px;
                line-height: 1.5;
                margin-top: 20px;
            }
        }
        &::after{
            content: "";
            width: 275px;
            margin: 0 30px 20px;
            display: block;
        }
    }
    @media only screen and (max-width: 1024px) {
        width: 100%;
        margin: 0;
        .list_wrap_mobile{
            border: 1px solid #e8eaed;
            border-radius: .1rem;
        }
        .list{
            padding: .4rem;
            display: block;
            .item{
                margin: 0;
                .cover{
                    height: 4rem;
                }
                .title{
                    font-size: .24rem;
                    margin-top: .2rem;
                }
            }
        }
    }
}
</style>